import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-bottom-header',
  templateUrl: './bottom-header.component.html',
  styleUrls: ['./bottom-header.component.scss']
})
export class BottomHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
